import { useState } from "react";
import "./AgregarCategoria.css";
import { useNavigate } from "react-router-dom";
  const API = process.env.REACT_APP_API_URL

export default function AgregarCategoria() {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [cargando, setCargando] = useState(false);

  const token = localStorage.getItem("token");
  const navigate = useNavigate();


  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch( API + "/user/refresh",{
        method:"POST",
         credentials: "include"
         
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    const categoria = { nombre, descripcion };

    try {
      let response = await fetch( API + "/categorias/agregarCategoria", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(categoria)
      });

       if (response.status === 403) {
        const renovado = await renovarToken();
        if (renovado) return await handleSubmit(); 
        return;
      }
     

      if (response.ok) {
        alert("Categoría agregada correctamente ✅");
        navigate("/categorias");
      } else {
        throw new Error("Error en el servidor");
      }
    } catch (error) {
      alert("❌ No se pudo agregar la categoría. Intenta de nuevo.");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="admin-container">
      <header className="form-header">
        <button className="btn-back" onClick={() => navigate(-1)}>← Volver</button>
        <h1>Nueva Categoría</h1>
        <p>Crea una nueva clasificación para tus productos.</p>
      </header>

      <main className="form-card">
        <form onSubmit={handleSubmit} className="form-categoria">
          <div className="input-group">
            <label htmlFor="nombre">Nombre de la categoría</label>
            <input
              id="nombre"
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              placeholder="Ej: Camisetas, Calzado, Accesorios..."
              required
              autoFocus
            />
          </div>

          <div className="input-group">
            <label htmlFor="descripcion">Descripción</label>
            <textarea
              id="descripcion"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Escribe una breve descripción de lo que incluirá esta categoría..."
              required
              rows="5"
            />
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              className={`btn-submit ${cargando ? 'loading' : ''}`}
              disabled={cargando}
            >
              {cargando ? "Guardando..." : "Guardar Categoría"}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}